import React from "react";

export default function Docs() {
  return (
    <div style={{ 
      width: "100%", 
      height: "calc(100vh - 60px)", 
      marginTop: "0px" 
    }}>
      <iframe
        src="https://api.kibo.aventiscali.com/docs"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
          borderRadius: "8px"
        }}
        title="API Documentation"
      />
    </div>
  );
}
